
import { ApiModule } from '@api/src/ApiModule'

export class Statuses extends ApiModule {
  constructor(props) {
    super(props)

    const isIgnition = this.isIgnition()
  }

  mapApplicationStatuses(application_statuses) {

    /**
     * TESTING TOTALS
     *
     * Documents Received: 3 (Move to "Submitted to Lender")
     * Submitted to Lender: 3 (total after move: 6)
     *
     */
    // let new_application_statuses = JSON.parse(JSON.stringify(application_statuses))
    let new_application_statuses = _.cloneDeep(application_statuses)

    application_statuses.forEach((e, i) => {
      // console.warn('STATUS', e)
      const moveTo = e.moveCardsTo
      const moveToIndex = new_application_statuses.findIndex((status) => status.label === moveTo)
      if (moveTo) {
        // console.warn(`MOVE STATUS TO: #${moveToIndex} (${moveTo})`)
        new_application_statuses[moveToIndex].data = new_application_statuses[moveToIndex].data.concat(e.data)
        new_application_statuses[moveToIndex].total = new_application_statuses[moveToIndex].total + e.total
      }
      return e
    })

    return new_application_statuses
  }
}
